// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2FVbS","Icon":"Languages_Icon__3DwAQ","LanguagesSelect":"Languages_LanguagesSelect__8zlkw","minimalist":"Languages_minimalist__3dVkM"};